export enum AuthResponseCode {
    AUTH_FAILED = 1,
    MFA_SETUP_REQUIRED = 2,
    MFA_CODE_SENT = 3,
    MFA_PHONE_VERIFIED = 4,
    MFA_FAILED = 5,
    MFA_SUCCESS = 6,
    FORCE_PASSWORD_CHANGE = 7,
    PASSWORD_RESET_EMAIL_SENT = 8,
    PASSWORD_RESET_SUCCESS = 9,
    AUTH_SUCCESS = 10
}


// WEBPACK FOOTER //
// ./src/app/auth/constants/auth-response-code.enum.ts